import { ETooltipVariant, GeneralHowToIcon, Tooltip } from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { getBookingOrQuoteCurrency } from '@/redux/selectors/checkout/currency';
import { formatCurrency } from '@/utility/currency';

interface IProps {
  securityDeposit?: number | null;
  className?: string;
}

const SecurityDeposit: React.FC<IProps> = ({ securityDeposit, className = '' }) => {
  const intl = useIntl();
  const currency = useSelector(getBookingOrQuoteCurrency);

  if (!securityDeposit) {
    return null;
  }
  const deposit = formatCurrency({
    priceInCents: securityDeposit || 0,
    currency,
    digits: 2,
  });

  const securityDepositMsg = intl.formatMessage({
    defaultMessage: 'Security deposit (refundable)',
    id: 'AkoJ7T',
  });

  return (
    <div className={`flex items-center pt-2 my-2 text-gray-900 text-500 autoType600 ${className}`}>
      <span>{securityDepositMsg} </span>
      <Tooltip
        content={
          <FormattedMessage
            defaultMessage={`2 days before your trip begins:{br} A hold goes on your payment method for the security deposit amount.{br} {br} Within 7 days after your trip ends:{br} The hold releases, so long as everything’s okay with the property.`}
            id="EeIXRS"
            values={{ br: <br /> }}
          />
        }
        placement="bottom-end"
        className="inline-flex"
        arrow={false}
        variant={ETooltipVariant.Dark}>
        <span className="flex items-center justify-center w-5 h-5 ml-1 border-none rounded-full text-gray-850 bg-canvas-200 hover:bg-gray-850 hover:text-white">
          <GeneralHowToIcon fontSize={20} />
        </span>
      </Tooltip>
      <span className="ml-auto">{deposit}</span>
    </div>
  );
};
export default SecurityDeposit;
